'use client';

import { FC, PropsWithChildren } from 'react';
import { OrdersProvider } from './_context/OrdersContext';

const OrdersLayout: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <OrdersProvider>{children}</OrdersProvider>
);

export default OrdersLayout;
